import md5 from 'js/library/utils/md5.jsx';
import CryptoJS from 'crypto-js';
import { getCurrentUserIdentifier } from 'js/library/services/currentUserInfo';

//icones
import alert from 'styles/assets/Messages/Alert.webp';
import establishment from 'styles/assets/Messages/Establishment.webp';
import news from 'styles/assets/Messages/News.webp';
import promotion from 'styles/assets/Messages/Promotion.webp';
import triibomania from 'styles/assets/Messages/Triibomania.webp';
import provider from 'styles/assets/Messages/Provider.webp';
import tribomania from 'styles/assets/Messages/Tribomania.webp';
import cfac22 from './cfac22';

export const loginRedirectKey = 'loginRedirectKey';

export function getCurrentDirectory() {
  const currentUrl = window.location.href;
  const domain = new URL(currentUrl).origin;

  return encodeURIComponent(currentUrl.replace(domain, ''));
}

window['alert'] = alert;
window['establishment'] = establishment;
window['news'] = news;
window['promotion'] = promotion;
window['triibomania'] = triibomania;
window['tribomania'] = tribomania;
window['provider'] = provider;

//confirma que a data é válida
export function confirmDate(date) {
  let validDay = true;
  let validMonth = true;
  let validYear = true;

  let day = date.substring(0, 2);
  if (day <= 31 && day > 0) {
    day = clamp(day, 1, 31);
  } else {
    validDay = false;
  }

  let month = date.substring(3, 5);
  if (month <= 12 && month > 0) {
    month = clamp(month, 1, 12);
  } else {
    validMonth = false;
  }

  let year = date.substring(6);
  if (year <= new Date().getFullYear() && year > 1900) {
    year = clamp(year, 1900, new Date().getFullYear());
  } else {
    validYear = false;
  }

  if (validMonth !== false && validDay !== false) {
    //meses com dia 30
    if (month === 4 || month === 6 || month === 9 || month === 11) {
      if (day > 30) {
        validDay = false;
      } else {
        validDay = true;
      }
    }

    //anos bissextos
    if (month === 2) {
      if (year % 4 === 0 && (year % 400 === 0 || year % 100 !== 0)) {
        if (day > 29) {
          validDay = false;
        } else {
          validDay = true;
        }
      } else {
        if (day > 28) {
          validDay = false;
        } else {
          validDay = true;
        }
      }
    }
  }
  month = month - 1;

  const finalDate = new Date(year.toString(), month.toString(), day.toString());

  if (finalDate <= Date.now() && validDay === true && validMonth === true && validYear === true) {
    return true;
  } else {
    return false;
  }
}

function clamp(value, min, max) {
  return Math.min(Math.max(value, min), max);
}

export function hashTriibo1(apiToken, passPhrase, channelToken) {
  let challenge1 = passPhrase + apiToken;
  challenge1 = md5.hexMD5(challenge1);

  let challenge2 = challenge1 + channelToken;
  challenge2 = md5.hexMD5(challenge2);

  return challenge2;
}

//mascaras

export function cellPhoneMask(value) {
  value = value.replace(/\D/g, '');

  let cellPhone = '';

  if (value.length === 0 || (value.length === 2 && value === '55')) {
    cellPhone = '';
  } else if (value.length === 1) {
    cellPhone = '+55 (' + value.substr(0, 1);
  } else if (value.length > 1 && value.length <= 4) {
    cellPhone = '+55 (' + value.substr(2, 2);
  } else if (value.length > 4 && value.length <= 9) {
    cellPhone = '+55 (' + value.substr(2, 2) + ') ' + value.substr(4, 5);
  } else {
    cellPhone = '+55 (' + value.substr(2, 2) + ') ' + value.substr(4, 5) + '-' + value.substr(9, 4);
  }

  return cellPhone;
}

export function maskCPF(cpf) {
  cpf = cpf.replace(/\D/g, '');
  cpf = cpf.replace(/(\d{3})(\d)/, '$1.$2');
  cpf = cpf.replace(/(\d{3})(\d)/, '$1.$2');
  cpf = cpf.slice(0, 13);
  cpf = cpf.replace(/(\d{3})(\d{1,2})$/, '$1-$2');
  return cpf;
}

export function maskCEP(cpf) {
  cpf = cpf.replace(/\D/g, '');
  cpf = cpf.replace(/(\d{5})(\d)/, '$1-$2');
  cpf = cpf.slice(0, 9);
  cpf = cpf.replace(/(\d{5})(\d{3})$/, '$1-$2');
  return cpf;
}

export function creditCardMask(value) {
  value = value.replace(/\D/g, '');

  let cardNumber = '';

  if (value.length === 0) {
    cardNumber = '';
  } else if (value.length >= 1 && value.length <= 4) {
    cardNumber = value.substr(0, 4);
  } else if (value.length > 4 && value.length <= 8) {
    cardNumber = value.substr(0, 4) + ' ' + value.substr(4, 4);
  } else if (value.length > 8 && value.length <= 12) {
    cardNumber = value.substr(0, 4) + ' ' + value.substr(4, 4) + ' ' + value.substr(8, 4);
  } else {
    cardNumber =
      value.substr(0, 4) +
      ' ' +
      value.substr(4, 4) +
      ' ' +
      value.substr(8, 4) +
      ' ' +
      value.substr(12, 4);
  }

  return cardNumber;
}

export function maskDate(value) {
  value = value.replace(/\D/g, '');

  let date = '';

  if (value.length === 0) {
    date = '';
  } else if (value.length > 0 && value.length < 3) {
    date = value.substr(0, 2);
  } else if (value.length > 2 && value.length < 5) {
    date = value.substr(0, 2) + '/' + value.substr(2, 2);
  } else {
    date = value.substr(0, 2) + '/' + value.substr(2, 2) + '/' + value.substr(4, 4);
  }

  return date;
}

//fim mascaras

export function encrypt(msg, key) {
  if (!msg) return null;

  const myEncrypt = {
    pass: CryptoJS.enc.Utf8.parse(key),
    iv: CryptoJS.enc.Hex.parse('0000000000000000'),
  };

  const options = {
    mode: CryptoJS.mode.CBC,
    iv: myEncrypt.iv,
  };

  const json = CryptoJS.AES.encrypt(msg, myEncrypt.pass, options);

  return json.ciphertext.toString(CryptoJS.enc.Base64);
}

export function decrypt(msg, key) {
  if (!msg) return null;

  msg = decodeURIComponent(msg);

  const myEncrypt = {
    pass: CryptoJS.enc.Utf8.parse(key),
    iv: CryptoJS.enc.Hex.parse('0000000000000000'),
  };

  const options = {
    mode: CryptoJS.mode.CBC,
    iv: myEncrypt.iv,
  };

  const json = CryptoJS.AES.decrypt(
    {
      ciphertext: CryptoJS.enc.Base64.parse(msg),
    },
    myEncrypt.pass,
    options
  );
  return json.toString(CryptoJS.enc.Utf8);
}

export function findIndexInArray(array, type, value) {
  let x = null;

  if (Array.isArray(array)) {
    array.map(function (array, i) {
      if (array !== null && array[type] === value) {
        x = i;
      }

      return x;
    });
  }

  return x;
}

export function findValueInArray(array, type, value) {
  let x = null;

  if (Array.isArray(array)) {
    array.map(function (array) {
      if (array !== null && array[type] !== undefined && array[type] === value) {
        x = array;
      }

      return x;
    });
  }

  return x;
}

export function detectmob() {
  if (
    navigator.userAgent.match(/Android/i) ||
    navigator.userAgent.match(/webOS/i) ||
    navigator.userAgent.match(/iPhone/i) ||
    navigator.userAgent.match(/iPad/i) ||
    navigator.userAgent.match(/iPod/i) ||
    navigator.userAgent.match(/BlackBerry/i) ||
    navigator.userAgent.match(/Windows Phone/i)
  ) {
    return true;
  } else {
    return false;
  }
}

export function formatUrl(data, uid) {
  //wifi_list -> mapa do wifi

  let url = '';

  if (data.action === 'browser' || data.action === 'webview') {
    url = data.appFilter.url;

    // Deve ser removido quando a nova api tiver sido corrigida com essa validação.
    if (url.includes('{uid}') && uid) {
      url = url.replace('{uid}', uid);
    }
  } else if (data.action === 'establishment_info') {
    url = '/estabelecimento/?id=' + data.appFilter.itemId;
  } else if (
    data.action === 'promotion_businessPartner' ||
    data.action === 'promotion_qrCode' ||
    data.action === 'promotion_selfValidation' ||
    data.action === 'promotion_takeVoucher' ||
    data.action === 'product_qrCode' ||
    data.action === 'product_selfValidation'
  ) {
    url = '/oferta/?id=' + data.appFilter.itemId;
  } else if (
    data.action === 'promotion_list' ||
    data.action === 'product_list' ||
    data.action === 'establishment_list'
  ) {
    url = '/ofertas/?id=' + data.cardId;
  }

  return url;
}

export function isFrameUrl(url) {
  if (!url) return false;

  return url.includes('/pagina-completa/') || url.includes('/pagina-interna/');
}

export function formatPostUrl(data) {
  //wifi_list -> mapa do wifi

  if (data.action === 'browser' || data.action === 'webview' || data.action === 'url') {
    return data.url;
  }

  if (data.action === 'establishment_info') {
    return '/estabelecimento/?id=' + data.itemId;
  }

  if (
    data.action === 'promotion_businessPartner' ||
    data.action === 'promotion_qrCode' ||
    data.action === 'promotion_selfValidation' ||
    data.action === 'promotion_takeVoucher' ||
    data.action === 'product_qrCode' ||
    data.action === 'product_selfValidation' ||
    data.action === 'promotion_item'
  ) {
    return '/oferta/?id=' + data.itemId;
  }

  if (
    data.action === 'promotion_list' ||
    data.action === 'product_list' ||
    data.action === 'establishment_list'
  ) {
    return '/ofertas/?id=' + data.postId;
  }

  if (data.action === 'app_screen') {
    const url = '/';
    switch (data.itemId) {
      case 'screen_home':
        return url;
      case 'screen_statement':
        return url + 'carteira';
      case 'screen_wallet':
        return url + 'carteira';
      case 'screen_profile':
        return url + 'meusDados';
      case 'screen_notifications':
        return url + 'caixaDeEntrada';
      case 'screen_recommended_orgs_list':
        return url + 'addTriibos';
      case 'screen_chat':
        return url + 'oferta/?id=-MYH-BH6SKtY6R7Wkzyb';
      default:
        return console.log('Não é um card interno válido');
    }
  }
}

export function formatDate(millis) {
  if (millis !== undefined) {
    const date = new Date(millis);
    return date.toLocaleDateString();
  } else {
    return null;
  }
}

//CONVERTE MILISEGUNDOS PARA DATA DD/MM/AAAA
export function toStoredUploadPath(fileUrl) {
  if (!fileUrl) return fileUrl;
  const value = String(fileUrl).trim();
  if (!value) return value;
  if (!/^https?:\/\//i.test(value)) {
    try {
      return `/${decodeURIComponent(value).replace(/^\/+/, '').split('?')[0]}`;
    } catch {
      return `/${value.replace(/^\/+/, '').split('?')[0]}`;
    }
  }
  try {
    const parsedUrl = new URL(value);
    if (parsedUrl.hostname === 'firebasestorage.googleapis.com') {
      const encodedPath = parsedUrl.pathname.split('/o/')[1];
      return encodedPath ? `/${decodeURIComponent(encodedPath).replace(/^\/+/, '')}` : value;
    }
    if (parsedUrl.hostname === 'storage.googleapis.com') {
      const [, bucket, ...filePath] = parsedUrl.pathname.split('/');
      return bucket && filePath.length > 0 ? `/${filePath.join('/')}` : value;
    }
  } catch {
    return value;
  }
  return value;
}

export function colorText(color) {
  return color || '#000000';
}

export function isValidDate(value) {
  if (typeof value !== 'string') return false;
  const match = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(value);
  if (!match) return false;
  const [, day, month, year] = match;
  const date = new Date(Number(year), Number(month) - 1, Number(day));
  return date.getFullYear() === Number(year) && date.getMonth() === Number(month) - 1 && date.getDate() === Number(day);
}

export function convertToDateDefault(date) {
  let converteddDate = new Date(date);

  const year = converteddDate.getFullYear();
  const month =
    converteddDate.getMonth() + 1 < 10
      ? '0' + (converteddDate.getMonth() + 1)
      : converteddDate.getMonth() + 1;
  const day =
    converteddDate.getDate() < 10 ? '0' + converteddDate.getDate() : converteddDate.getDate();

  converteddDate = day + '/' + month + '/' + year;

  return converteddDate;
}

export function formatPhone(value) {
  value = value.replace(/\D/g, '');

  return '(' + value.substr(0, 2) + ') ' + value.substr(2, 4) + '-' + value.substr(6, 4);
}

// export function triiboCodeMask(props) {
//   const { inputRef, ...other } = props;

//   return (
//     <MaskedInput
//       {...other}
//       ref={(ref) => {
//         inputRef(ref ? ref.inputElement : null);
//       }}
//       mask={['T', '-', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]}
//       placeholderChar={'\u2000'}
//     />
//   );
// }

export function b64toBlob(file) {
  file = file.split(',');

  const b64Data = file[1];
  const data = file[0].split(';');
  const newData = data[0].split(':');

  const contentType = newData[1];

  const byteCharacters = atob(b64Data);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += 512) {
    const slice = byteCharacters.slice(offset, offset + 512);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);

    byteArrays.push(byteArray);
  }

  const blob = new Blob(byteArrays, { type: contentType });

  return blob;
}

export function placeIsOpen(hours) {
  let open = false;

  const currentTime = new Date();

  if (hours !== undefined && hours[currentTime.getDay()].ativo) {
    if (
      (currentTime.getHours() >
        parseInt(hours[currentTime.getDay()].horarioInicio.split(':')[0], 10) ||
        (currentTime.getHours() ===
          parseInt(hours[currentTime.getDay()].horarioInicio.split(':')[0], 10) &&
          currentTime.getMinutes() >=
          parseInt(hours[currentTime.getDay()].horarioInicio.split(':')[1], 10))) &&
      (currentTime.getHours() <
        parseInt(hours[currentTime.getDay()].horarioFim.split(':')[0], 10) ||
        (currentTime.getHours() ===
          parseInt(hours[currentTime.getDay()].horarioFim.split(':')[0], 10) &&
          currentTime.getMinutes() <=
          parseInt(hours[currentTime.getDay()].horarioFim.split(':')[1], 10)))
    ) {
      open = true;
    }
  }

  return open;
}

export function getUrlVariables() {
  const GET = {};
  if (document.location.toString().indexOf('?') !== -1) {
    const query = document.location
      .toString()
      .replace(/^.*?\?/, '')
      .replace(/#.*$/, '')
      .split('&');

    for (let i = 0, l = query.length; i < l; i++) {
      const aux = decodeURIComponent(query[i]).split('=');
      GET[aux[0]] = aux[1];
    }
  }

  return GET;
}

export function validateDuration(registrationDate, days) {
  try {
    const mkTime = new Date(registrationDate).getTime() / 1000.0;
    const mkTimeCurrent = new Date().getTime() / 1000.0;
    const date = Math.floor((mkTimeCurrent - mkTime) / 60 / 60 / 24);

    if (date > days || registrationDate === null) {
      return false;
    } else {
      return true;
    }
  } catch {
    return false;
  }
}

export function validateRegistrationDate(registrationDate, minutes) {
  try {
    const mkTime = new Date(registrationDate).getTime() / 1000.0;
    const mkTimeCurrent = new Date().getTime() / 1000.0;

    const date = Math.floor((mkTimeCurrent - mkTime) / 60);

    if (date > minutes || registrationDate === null) {
      return false;
    } else {
      return true;
    }
  } catch {
    return false;
  }
}

export function getMobileOperatingSystem() {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;

  if (/android/i.test(userAgent)) {
    return 'Android';
  }

  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return 'iOS';
  }

  return 'Android';
}

export function debounce(func, wait, immediate) {
  let timeout;
  return function (...args) {
    const context = this;
    const later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

export async function startMatomo() {
  if (navigator.userAgent.indexOf('iPhone') > -1) {
    const viewport = document.querySelector('[name=viewport]');
    const userId = getCurrentUserIdentifier();

    if (viewport) {
      viewport.setAttribute('content', 'width=device-width, initial-scale=1, maximum-scale=1');
    }
  }

  if (window.__triiboMatomoStarted) {
    if (userId && window.__triiboMatomoUserId !== userId) {
      _paq.push(['setUserId', userId]);
      window.__triiboMatomoUserId = userId;
    }
    return;
  }

  window.__triiboMatomoStarted = true;

  _paq.push(['enableLinkTracking']);
  (function () {
    const u = 'https://matomo.triib.io/';
    _paq.push(['setTrackerUrl', u + 'matomo.php']);
    _paq.push(['setSiteId', cfac22('idMatomo')]);
    if (userId) {
      _paq.push(['setUserId', userId]);
      window.__triiboMatomoUserId = userId;
    }

    setTimeout(() => {
      _paq.push(['HeatmapSessionRecording::captureInitialDom', 38]);
    }, 3000);

    if (document.querySelector('script[data-triibo-matomo="true"]')) return;

    const d = document,
      g = d.createElement('script'),
      s = d.getElementsByTagName('script')[0];
    g.type = 'text/javascript';
    g.async = true;
    g.dataset.triiboMatomo = 'true';
    g.src = u + 'matomo.js';
    s.parentNode.insertBefore(g, s);
  })();
}

export function trackEventMatomo(location, event, element, elementName) {
  const elementType = `element:${element}; elementName:${elementName}`;

  const _paq = (window._paq = window._paq || []);
  _paq.push(['trackEvent', location, event, elementType]);
}

export function trackEventMatomoElementId(location, event, element, elementId) {
  const elementType = `element:${element}; elementId:${elementId}`;

  const _paq = (window._paq = window._paq || []);
  _paq.push(['trackEvent', location, event, elementType]);
}

export function trackEventMatomoVisit(locationName) {
  const _paq = (window._paq = window._paq || []);
  _paq.push(['trackEvent', locationName, 'visualizar', window.location.href, 0]);
}

export function getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
  const R = 6371; // Radius of the earth in km
  const dLat = deg2rad(lat2 - lat1); // deg2rad below
  const dLon = deg2rad(lon2 - lon1);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const d = R * c; // Distance in km
  return d;
}

function deg2rad(deg) {
  return deg * (Math.PI / 180);
}

export function generateRandom(length) {
  let result = '';
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

export function moveElement(array, fromIndex, toIndex) {
  const arrayCopy = [...array];
  const element = arrayCopy.splice(fromIndex, 1)[0];

  arrayCopy.splice(toIndex, 0, element);

  return arrayCopy;
}

export function hexToRgb(hex) {
  // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
  try {
    const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    hex = hex.replace(shorthandRegex, function (m, r, g, b) {
      return r + r + g + g + b + b;
    });

    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result
      ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
      }
      : null;
  } catch {
    return null;
  }
}

// export function buildRegisterPayload({ registerData, code, partnerId, fingerprint }) {
//   const cpfClean = registerData.cpf?.replace(/\D/g, '') ?? '';
//   const phoneNumber = registerData.cellphone || registerData.identifier || '';

//   // Se fullName, name e lastName vierem prontos, usa eles
//   const fullName = registerData.fullName || (registerData.name || '').trim();
//   const firstName = registerData.name || '';
//   const lastName = registerData.lastName || '';

//   return {
//     identifier: phoneNumber,
//     cellPhone: phoneNumber,
//     partnerId,
//     code,
//     clientType: 'web',
//     fingerprint,
//     data: {
//       aliasName: registerData.aliasname || firstName,
//       fullName,
//       name: firstName,
//       lastName,
//       partnerName: 'Triibo',
//       userOrigin: 'Triibo',
//       contactList: [
//         ...(registerData.email ? [{ type: 'email', value: registerData.email }] : []),
//         { type: 'cellPhone', value: phoneNumber },
//       ],
//       documentList: cpfClean ? [{ type: 'cpf', value: cpfClean }] : [],
//       codStatus: '5',
//       optInList: [
//         {
//           accept: true,
//           version: 1,
//           type: 'Termos de Uso da Triibo',
//           dateAcceptance: Date.now(),
//           optInId: '-Kzj_F6wDcfHkLMO_q4c',
//         },
//       ],
//       additionalInfo: {},
//     },
//   };
// }

export function buildRegisterPayload({ registerData, code, partnerId, fingerprint }) {
  const phoneNumber = registerData.cellphone || registerData.identifier || '';
  const dynamicData = registerData.dynamicData || {};
  const dataWithoutEmptyFields = Object.fromEntries(
    Object.entries(dynamicData).filter(
      ([, value]) => value !== '' && value !== undefined && value !== null
    )
  );
  return {
    identifier: phoneNumber,
    cellPhone: phoneNumber,
    partnerId,
    code,
    clientType: 'web',
    fingerprint,
    data: {
      ...dataWithoutEmptyFields,
      ...(phoneNumber
        ? {
          contactList: [
            ...(dynamicData.contactList || []).filter((item) => item?.type !== 'cellPhone'),
            { type: 'cellPhone', value: phoneNumber },
          ],
        }
        : {}),
      ...(dynamicData.documentList ? { documentList: dynamicData.documentList } : {}),
      ...(dynamicData.addressList ? { addressList: dynamicData.addressList } : {}),
      ...(dynamicData.optInList ? { optInList: dynamicData.optInList } : {}),
      ...(dynamicData.otherBlocks ? { otherBlocks: dynamicData.otherBlocks } : {}),
    },
  };
}
